import { ROUTES } from "../../../utils/constants";
import { useSelector } from "react-redux";
import Loader from "../../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import { getAuth } from "../../../redux/auth/authSlice";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Box, createTheme, ThemeProvider, Typography } from "@mui/material";
import { useHomeSiteObserver } from "../../../reactQuery/homeSites/homsites/homeSiteQuery";
import {
     useMileStoneTasksData,
     useMileStoneTasksIncrementalData,
} from "../../../reactQuery/homeSites/milestones/mileStoneTasksQuery";
import MetricsCardComponent from "./metricsComponent";
import ChartComponent from "./chartsComponent";
import ConciergeFilterComponent from "../concierge/ConciergeFilterComponent";
import TaskMetricsComponent from "./taskMetricsComponent";
import { theme } from "../../../components/gridToolbarComponents/gridToolbarComponents";
import { useDivisionMileStoneDataReleased } from "../../../reactQuery/division/divisionMileStoneQuery";
import { DivisionMileStones } from "../../../api/divisionMileStones/types";
import { useHomeSiteDataIndexQuery } from "../../../reactQuery/homeSitesDataIndex/homeSiteDataIndexQuery";

export const Dashboard: React.FC = () => {
     const navigate = useNavigate();
     const { userInfo } = useSelector(getAuth);
     // Data load
     // Data Index Query
     const { data: homeSitesDataIndex, pending: isLoadingHomeSites } = useHomeSiteDataIndexQuery(userInfo.userDivCode)
     const { metrics: counts, applyDynamicFilters, filteredHomesites } = useHomeSiteObserver(homeSitesDataIndex || [])
     const { data: divisionMilestones } = useDivisionMileStoneDataReleased(userInfo.userDivCode)
     const { data: tasks } = useMileStoneTasksData(userInfo.userDivCode)
     // Incremental data load
     const incrementalDataLoad = useMileStoneTasksIncrementalData(userInfo.userDivCode, tasks?.continuationToken ?? "");

     const NoDataMessage = () => (
          <Box
               style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
               }}
          >
               <h2>No Data Available</h2>
          </Box>
     );
     const LoaderWrapper =
          ({ isLoading, children, incrementalDataLoad }: { isLoading: boolean; children: React.ReactNode; incrementalDataLoad: boolean }) => ((isLoading || incrementalDataLoad) ? <Loader /> : <>{children}</>);

     return (
          <ThemeProvider theme={theme}>
               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 }}>
                    <Typography variant="h2" sx={{ fontWeight: "400", color: "#000000", fontSize: "32px", fontFamily: "Reckless" }}>{ROUTES.closings.myConcierge.label}</Typography>
                    <ConciergeFilterComponent applyDynamicFilters={applyDynamicFilters} />
               </Box>
               <LoaderWrapper isLoading={isLoadingHomeSites} incrementalDataLoad={incrementalDataLoad.isLoading}>
                    {homeSitesDataIndex?.length === 0 ? (
                         <NoDataMessage />
                    ) : (
                         <Box sx={{ display: "flex", flexDirection: "column", gap: 2, minHeight: "100%" }}>
                              <MetricsCardComponent metrics={counts} navigate={navigate} />
                              <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, borderRadius: "4px", gap: 2, marginTop: 2 }}>
                                   <ChartComponent metrics={counts} navigate={navigate} isloading={isLoadingHomeSites} isIncrementalLoading={incrementalDataLoad.isLoading} />
                                   <TaskMetricsComponent
                                        filteredHomeSites={filteredHomesites}
                                        navigate={navigate}
                                        tasks={tasks?.data || []}
                                        divisionMilestones={divisionMilestones || new DivisionMileStones("0", [])}
                                        isLoading={incrementalDataLoad.isLoading}
                                   />
                              </Box>
                         </Box>
                    )}
               </LoaderWrapper>
          </ThemeProvider>
     );
};
